import { userRole } from "@/types/user";
import { ApiEndpointBuilder } from "@/services/api/types";
import { usersApi } from ".";
import { isNullUUID } from "@/utils/data";
import { invitationsApi } from "@/store/invitations/endpoints";
import { PlanType } from "@/store/tenants/endpoints/tenants";

const InviteUser = (builder: ApiEndpointBuilder) => {
  return builder.mutation<string, Request>({
    query: ({ firstName, lastName, ...request }) => ({
      url: "/users/invite",
      method: "POST",
      body: request,
    }),
    async onQueryStarted(args, { queryFulfilled, dispatch }) {
      try {
        const { data } = await queryFulfilled;
        if (data && !isNullUUID(data)) {
          dispatch(
            usersApi.util.updateQueryData("searchUsers", {}, draftList => {
              draftList.data.unshift({
                ...args,
                roles: args.userRoles?.filter(role => role.enabled).map(role => role.roleName),
                licenses: args.licenses,
              });
            })
          );
        } else if (isNullUUID(data)) {
          dispatch(invitationsApi.util.invalidateTags(["usersInvitationsList"]));
        }
      } catch (error) {
        console.error(error);
      }
    },
    invalidatesTags: ["tenantDetails"],
  });
};

type Request = {
  firstName?: string;
  lastName?: string;
  email?: string;
  userRoles?: userRole[];
  licenses: PlanType[];
  reason: InvitationReason;
};

export enum InvitationReason {
  Join = 1,
  UseCrmVaultLicense = 2,
  JoinAndUseCrmVaultLicense = 3,
}

export default InviteUser;
